import { Injectable } from '@angular/core';
import { ApiUrlHelper } from '../api-url-helper';
import { BehaviorSubject } from 'rxjs';
import { HttpClientHelper } from '../http-helper';
import { VideoTransFormer } from '../../_transformers/video.transformer';
import { map } from 'rxjs/operators';

@Injectable()
export class RankedVideosService {
    rankedVideos = [];
    private _rankedVideosService = new BehaviorSubject<any>([]);
    rankedVideosSource$ = this._rankedVideosService.asObservable();

    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _videoTransFormer: VideoTransFormer,
    ) { }

    updateRankedVideos() {
        this.getRankedVideos().subscribe(r => {
            this.rankedVideos = r;
            this._rankedVideosService.next(this.rankedVideos);
        });
    }

    getRankedVideos() {
        const apiURL = this._apiUrlHelper.urlBuilder('all-ranked-videos', {});
        return this._httpClientHelper.getWithCache(apiURL)
        .pipe(map((res) => {
                return res.map(list => {
                    return {
                        cid: list.cid,
                        items: list.rankList.map(item => {
                            return this._videoTransFormer.transformFromRankedList(item);
                        }),
                    };
                });
            }));
    }
}
